import { Ajax } from "./../../../../Content/js/Extensions/ajax";
import { Form } from "./../../../../Content/js/Extensions/form";
import { Utils } from "./../../../../Content/js/Extensions/utils";

const keyCodeSubmit = 13;
const keyCodeUp = 38;
const keyCodeDown = 40;
const keyCodeClear = 27;
const ignoredKeyCodes = [keyCodeSubmit, keyCodeUp, keyCodeDown, keyCodeClear];

const activeResultClass = "_active-item";
const body = document.body;

function initAutoSuggestion() {
    const searchForms = document.querySelectorAll(".js-autosuggestion");
    if (!searchForms || searchForms.length === 0) {
        return;
    }

    const searchFormsArray = Array.from(searchForms);
    searchFormsArray.forEach((searchForm) => {
        initSearchForm(searchForm);
    });
}

function initSearchForm(searchForm) {
    const debounceSubmitForm = Utils.debounce(submitForm, 100);
    const input = searchForm.querySelector("input[type=text]");
    const clear = searchForm.querySelector(".js-autosuggestion__clear");
    const searchLink = searchForm.querySelector(".js-autosuggestion__searchlink");
    const searchContauner = searchForm.querySelector(".js-search__container");
    const searchInputHolder = searchForm.querySelector(".js-search__input-holder");

    const suggestionList = searchForm.querySelector(".js-autosuggestion__list");
    const redirectPath = searchForm.querySelector('input.js-autosuggestion__searchurl').value + "?q=";

    let path;
    let results;
    let activeResultIndex = 0;
    let isPostSuccess = false;

    if (!input || !clear || !suggestionList) return;
    initListeners();

    function onSubmit(e) {
        e.preventDefault();
    }

    function onSuccess(data) {
        isPostSuccess = true;
        suggestionList.innerHTML = data;
        setTimeout(initKeyNav, 0);
    }

    function onError(data) {
        alert(`Something wrong with respond ${data.message}`);
    }

    function initListeners() {
        searchForm.addEventListener("submit", onSubmit);
        input.addEventListener("click", toggleSearch);
        input.addEventListener("keyup", debouncedSubmit);
        input.addEventListener("keydown", checkKeyCode);
        body.addEventListener("click", toggleSearch);
        clear.addEventListener("click", clearSearch);
        input.addEventListener("change", updateSearchLink);
    }

    function updateSearchLink(e) {
        searchLink.href = redirectPath + e.target.value;
    }

    function checkKeyCode(e) {
        if (e.keyCode === keyCodeSubmit && isPostSuccess) window.location.href = path;
    }

    function submitForm() {
        if (!input.value || input.value.length < 2) return;
        const data = Form.serialize(searchForm);
        Ajax.post("/", data, onSuccess, onError);
    }

    function toggleSearch() {
        if (input === document.activeElement) {

            addKeyListeners();
            if (results) {
                activeResultIndex = 0;
                setActiveState();
            }
        } else {
            removeKeyListeners();
        }
    }

    function addKeyListeners() {
        body.addEventListener("keyup", keyListener);
    }

    function removeKeyListeners() {
        body.removeEventListener("keyup", keyListener);
    }

    function keyListener(e) {
        e.preventDefault();
        const keyCode = e.keyCode;
        switch (keyCode) {
            case keyCodeClear:
                clearSearch();
                break;
            case keyCodeUp:
                changeActiveIndex(-1);
                setActiveState();
                break;
            case keyCodeDown:
                changeActiveIndex(1);
                setActiveState();
                break;
        }
    }

    function changeActiveIndex(koef) {
        activeResultIndex += koef;

        if (activeResultIndex < 0) {
            activeResultIndex = results.length - 1;
        } else if (activeResultIndex > results.length - 1) {
            activeResultIndex = 0;
        }
    }

    function getSearchResulUrl() {
        let activeResult = results[activeResultIndex];
        let url;

        if (activeResult.tagName === "A") {
            url = activeResult.getAttribute("href");
        } else {
            url = `${redirectPath}${activeResult.value}`;
        }

        return url;
    }

    function clearSearch() {
        input.value = "";
        suggestionList.innerText = "";
    }

    function debouncedSubmit(e) {
        e.preventDefault();
        if (ignoredKeyCodes.indexOf(e.keyCode) === -1) {
            debounceSubmitForm();
        }
    }

    function initKeyNav() {
        let resultsNodes = suggestionList.querySelectorAll("a");

        results = [...resultsNodes];
        results.unshift(input);
        activeResultIndex = 0;

        setActiveState();
    }

    function setActiveState() {
        results.forEach((item) => item.classList.remove(activeResultClass));
        results[activeResultIndex].classList.add(activeResultClass);
        path = getSearchResulUrl();
    }

    function initToggleSearchLink() {
        const screenWidth = screen.width;
        const phoneMaxWidth = 768;

        if (screenWidth > phoneMaxWidth) {
            searchLink.addEventListener("click", () => {
                searchContauner.classList.toggle("_show");
                input.focus();
            });
        }
    }

    initToggleSearchLink();
}

export default initAutoSuggestion;


// WEBPACK FOOTER //
// ./uPortal/Core/Shared/AutoSuggestions/Js/index.js